import { Controller } from "@hotwired/stimulus"

// The bank-review strip (budgets/_bank_review). Tapping it opens the
// bank-review deck (bank_review_deck_controller), which is mounted once on the
// dashboard rather than on every budget panel — the same hand-off the Due
// today card makes to its deck (due_today_card_controller#open).
export default class extends Controller {
  open() {
    this.dispatch("open", { prefix: "bank-review-deck" })
  }
}
